enum DataShareStatus {
  Active = "Active",
  Inactive = "Inactive",
}

enum DataShareDatabaseStatus {
  Ready = "Ready",
  NotProvisioned = "Not Provisioned",
}

enum DataShareListingPublishedStatus {
  Published = "Published",
  Unpublished = "Unpublished",
}

enum DataShareBatchStatus {
  Unknown = "Unknown",
  Complete = "Complete",
  Running = "Running",
}

enum Tabs {
  Dashboard = "Dashboard",
  SharingRunMonitor = "Sharing Run Monitor",
  SnowflakeIntegration = "Snowflake Integration",
}

enum TriggerListingRefreshOutcome {
  Triggered = "triggered",
  AlreadyRunning = "alreadyRunning",
  ListingNotPublished = "listingNotPublished",
}

export { DataShareStatus, DataShareDatabaseStatus, DataShareListingPublishedStatus, DataShareBatchStatus, Tabs, TriggerListingRefreshOutcome };
